export const container = `flex flex-col min-w-48 max-w-80`;
